import axios from 'axios';

let _svc;
let _eventCode = "";
let _configCode = "";

export default {
    init: (apiUrl) => {
        //console.log("intiating svc - " + apiUrl);
        _svc = axios.create({
            baseURL: apiUrl
        });
    },

    setEventCodeAndConfigCode: (eventCode, configCode) => {
        _eventCode = eventCode;
        _configCode = configCode;
    },

    getEventSettings: () => {
        return _svc.get(`certificate/eventsettings/${_eventCode}/${_configCode}`)
    },

    login: (loginCode, password) => {
        return _svc.post(`certificate/login/${_eventCode}/${_configCode}`,
            {
                loginCode: loginCode,
                password: password
            });
    },

    loginByQueryString: (personId, personHash) => {
        return _svc.post(`certificate/LoginByQueryString/${_eventCode}/${_configCode}`,
            {
                personId: personId,
                personHash: personHash,
            });
    },

    loginByEncryptedUser: (encryptedUser) => {
        return _svc.post(`certificate/LoginByEncryptedUser/${_eventCode}/${_configCode}`,
            {
                encryptedUser: encryptedUser
            });
    },

    LoginAfterSurveyCompletedNoParams: (loginCode, password, surveyCode) => {
        return _svc.post(`certificate/LoginAfterSurveyCompletedNoParams/${_eventCode}/${_configCode}`,
            {
                loginCode: loginCode,
                password: password,
                surveyCode: surveyCode
            });
    },

    surveyCompletedWithParams: (barcode, surveyCode, surveyHash) => {
        return _svc.post(`certificate/SurveyCompletedWithParams/${_eventCode}/${_configCode}`,
            {
                barcode: barcode,
                surveyCode: surveyCode,
                surveyHash: surveyHash
            });
    },

    surveyCompletedNoParams: (barcode, barcodeHash, surveyCode) => {
        return _svc.post(`certificate/SurveyCompletedNoParams/${_eventCode}/${_configCode}`,
            {
                barcode: barcode,
                barcodeHash: barcodeHash,
                surveyCode: surveyCode
            });
    }
}